import { Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  position: absolute;
  top: 43px;

  &.table-scroll-buttons__button-left {
    left: -30px;
  }

  &.table-scroll-buttons__button-right {
    right: -30px;
  }

  &.table-scroll-buttons__button-left,
  &.table-scroll-buttons__button-right {
    border-radius: 0;
    opacity: 1;
    visibility: visible;
    transition: visibility 0.1s linear, opacity 0.1s linear;
    width: 30px;
    height: 30px;
    border: none;
    background-color: ${(props): string => props.theme.kcc.colors.BLACK};
    user-select: none;

    :hover {
      background-color: ${(props): string => props.theme.kcc.colors.BLACK} !important;
    }

    :active {
      background-color: ${(props): string => props.theme.kcc.colors.BLACK} !important;
    }

    .ant-btn-icon {
      width: 100%;
      height: 100%;
    }
  }

  &.table-scroll-buttons__button-left--hidden,
  &.table-scroll-buttons__button-right--hidden {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: visibility 0.1s linear, opacity 0.1s linear;
  }
`;
